"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-8">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-primary/10 animate-pulse rounded" />)}
      </div>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList className="gap-12">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="text-[0.875rem] font-sans font-medium uppercase tracking-widest text-foreground/80 hover:text-primary transition-colors duration-300">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <button className="md:hidden bg-primary text-secondary rounded-lg hover:bg-primary-600 transition-colors flex items-center justify-center p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </button>

      {}
      {mobileMenuOpen && <div className="fixed inset-0 top-[88px] z-50 bg-secondary/98 backdrop-blur-xl md:hidden animate-in fade-in slide-in-from-top-4 duration-300">
          <nav className="container mx-auto px-6 py-12">
            <ul className="flex flex-col items-center gap-8">
              {menuItems.map((item, i) => <li key={item.id} data-index={i} className="w-full text-center">
                  <Link to={item.href || "#"} className="block text-xl font-serif text-foreground hover:text-primary transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Cabecera() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="cabecera" className="fixed top-0 z-50 w-full transition-all duration-500 bg-secondary ![padding:20px_32px_20px_32px]">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          <div className="flex-shrink-0">
            <Link to="/" aria-label="Aceite Paco y Herminia" className="block transition-transform duration-300 hover:scale-105">
              <span className="font-serif text-xl font-semibold tracking-tight text-primary whitespace-nowrap ![margin:60px_60px_60px_0px] md:text-2xl">
                Aceite Paco & Herminia
              </span>
            </Link>
          </div>

          <div className="flex items-center">
            <MenuProvider menu_id="3" className="flex items-center">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>
        </div>
      </div>
    </section>;
}